import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectMarketResultsReportParams } from '@/shared/api/end-points/project'
import { MarketResultsResponse } from '../../lib'

const getMarketResultsReport = async (params: GetProjectMarketResultsReportParams) => {
  return await api.json<MarketResultsResponse>(API_END_POINTS.project.getProjectMarketResultsReport(params))
}

export default getMarketResultsReport
